export const getEmailsAndEmailFromState = (state) => {
  const { emails, email } = state;
  return { emails, email };
};
